function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1{opacity:0.3;isolation:isolate;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1441",
  "data-name": "Path 1441",
  className: "cls-1",
  d: "M10,0a10,10,0,1,0,7.071,2.929A10,10,0,0,0,10,0Zm0,17.429A7.427,7.427,0,1,1,17.427,10h0A7.437,7.437,0,0,1,10,17.43Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1442",
  "data-name": "Path 1442",
  className: "cls-2",
  d: "M4.6,1.616A9.956,9.956,0,0,0,.252,7.947l2.557.328a7.442,7.442,0,0,1,7.327-5.694L10.46.03A10.016,10.016,0,0,0,4.643,1.592Z"
});

var SvgLoaderWhite = function SvgLoaderWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoaderWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader-white.d62bfa80.svg";
export { ForwardRef as ReactComponent };